

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    Checkout Section Component-->
    <checkout-page-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import CheckoutPageArea from "../components/products/CheckoutPageArea";

export default {
  name: 'Checkout',
  components: {CheckoutPageArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Checkout',
        link: 'Checkout'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Checkout.vue